import React from 'react';

import { TextField, TextFieldProps } from '@mui/material';

import { getTimeValues } from 'views/Product/__utils/time';
import { useTranslation } from 'services/localization/useTranslation';

const TimeValueOptions = () => {
	return (
		<>
			{getTimeValues().map((timeValue) => (
				<option key={timeValue} value={timeValue}>
					{timeValue}
				</option>
			))}
		</>
	);
};

interface Props {
	value: number | '';
	onChange: (value: number) => void;
	textFieldProps?: TextFieldProps;
}

const TimeValueSelect = (props: Props) => {
	const { t } = useTranslation();

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		props.onChange(parseInt(e.target.value, 10));
	};

	return (
		<TextField
			select
			label={t('common:times.time')}
			value={props.value}
			onChange={handleChange}
			margin="normal"
			type="number"
			fullWidth
			SelectProps={{
				native: true,
			}}
			{...props.textFieldProps}
		>
			<TimeValueOptions />
		</TextField>
	);
};

export default TimeValueSelect;
